export default "__VITE_ASSET__CSQyjKNC__"